export default __webpack_public_path__ + "static/media/top_collage_searching_project-5.263ad4b6.png";